export const isExternalLink = (url: string): boolean => {
  const bounceUrlExp = /^(https:\/\/)?(www\.)?(bounce\.com|usebounce\.com)(.*)/i
  if (url.match(bounceUrlExp)) return false

  const absoluteUrlExp = /^(https?:)?\/\//i
  if (url.match(absoluteUrlExp)) return true

  return false
}
